import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoicingCategory\UpdateInvoicingCategoryController::__invoke
* @see app/Http/Controllers/InvoicingCategory/UpdateInvoicingCategoryController.php
* @route '/api/invoicing-category/{invoicingCategory}'
*/
const UpdateInvoicingCategoryController = (args: { invoicingCategory: string | number | { id: string | number } } | [invoicingCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateInvoicingCategoryController.url(args, options),
    method: 'put',
})

UpdateInvoicingCategoryController.definition = {
    methods: ["put"],
    url: '/api/invoicing-category/{invoicingCategory}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\InvoicingCategory\UpdateInvoicingCategoryController::__invoke
* @see app/Http/Controllers/InvoicingCategory/UpdateInvoicingCategoryController.php
* @route '/api/invoicing-category/{invoicingCategory}'
*/
UpdateInvoicingCategoryController.url = (args: { invoicingCategory: string | number | { id: string | number } } | [invoicingCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoicingCategory: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoicingCategory: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoicingCategory: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoicingCategory: typeof args.invoicingCategory === 'object'
        ? args.invoicingCategory.id
        : args.invoicingCategory,
    }

    return UpdateInvoicingCategoryController.definition.url
            .replace('{invoicingCategory}', parsedArgs.invoicingCategory.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoicingCategory\UpdateInvoicingCategoryController::__invoke
* @see app/Http/Controllers/InvoicingCategory/UpdateInvoicingCategoryController.php
* @route '/api/invoicing-category/{invoicingCategory}'
*/
UpdateInvoicingCategoryController.put = (args: { invoicingCategory: string | number | { id: string | number } } | [invoicingCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateInvoicingCategoryController.url(args, options),
    method: 'put',
})

export default UpdateInvoicingCategoryController